// @flow

import Decimal from 'decimal.js';

const getFinalBottlesAndCases = ({ item, values }: any) => {
  const uom = item.Uom || 1;
  const bottles = new Decimal(values.Bottles / uom).toDecimalPlaces(5, 1);
  const extraCases = bottles.truncated().toNumber();
  const finalBottles = parseInt(
    Math.ceil((bottles.toNumber() - extraCases) * uom),
    10,
  );
  const finalCases = values.Cases + extraCases;

  return {
    Bottles: finalBottles,
    Cases: finalCases,
  };
};

export { getFinalBottlesAndCases };
